import DateTitle from './styled';

export default DateTitle;
